
      if (!import.meta.env.DEV) {
        const script = document.createElement("script");
        script.defer = true;
        script.src = "/script.js";
        script.setAttribute(
          "data-website-id",
          "a776d152-92f7-4f53-b358-312646289a63",
        );
        script.setAttribute("data-performance", "true");
        document.head.appendChild(script);
      }
    